export default {"src":"/_next/static/image/public/images/ic_complete_profile.451a8afcc30a52d28aeec2843bb7efa1.svg","height":110,"width":100};